// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"6c39a866","113":"221549b5","560":"13b94988","593":"0bed15e6","652":"26035562","667":"4d51410a","787":"8e3e6d58"}[chunkId] + ".chunk.js";
};